import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './Home.css';

import LAND23 from '../images/land23.jpeg'; // Adjust path as necessary
import HOUSE1 from '../images/HOUSE1.png'; // Adjust path as necessary
import INSURANCE from '../images/INSURANCE.jpg'; // Adjust path as necessary
import RENTALSHOP from '../images/RENTALSHOP.jpg'; // Adjust path as necessary
import OFFICERENT from '../images/OFFICERENT.jpg'; // Adjust path as necessary
import Topbar from './Topbar';
import LANDpic from '../images/LANDpic.jpg'; // Adjust path as necessary
import Rating from './Rating';
import Upload from './Upload';
import Reviews from './Reviews';
export default function Home() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <div>
      <div><Topbar/></div>
      <div><Navbar /></div>
      <div>
        <section id="hero" style={{ backgroundImage: `url(${LAND23})`}}>
          <div className="hero-content">
            <h1>APPOLLO AGENCY</h1>
            <p>"Turning Visions into Reality, One Property at a Time"</p>
            <a href="tel:+919884226561" className="hero-btn">Book Service?</a>
          </div>
        </section>

        <section id="About">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="about-heading">
          <h2>About</h2>
        </div>
        <p>
        Welcome to Apollo Agency! With over 32 years of excellence in the real estate and LIC (Life Insurance Corporation) industry, we are your trusted partner for tailored solutions that meet your unique needs. At Apollo Agency, we specialize in providing exceptional customer-focused services, ensuring every client receives the personalized attention they deserve.
        </p>
        <p>
        We pride ourselves on our unwavering commitment to transparency and professionalism. Building trust with our clients is at the heart of everything we do, and we ensure you are informed every step of the way. Our seasoned professionals leverage decades of expertise to deliver results that consistently exceed expectations.
        </p>
        <p>
        Customer satisfaction remains our driving force. Whether you need strategic real estate guidance, insurance planning, or hands-on support, Apollo Agency is here to help you achieve your goals with reliability and expertise. Thank you for choosing Apollo Agency—where your success and peace of mind are our mission!
        </p>
      </div>
    </div>
  </div>
  
</section>




<section id="gallery" className="container my-5">
  
  <div className="row align-items-center mb-4">
    <div className="col-md-6">
      <div className="card">
        <img src={HOUSE1} alt="Gallery Image 1" className="img-fluid rounded card-img-top" />
        <div className="card-body">
          <h3 className="card-title">House</h3>
          <p className="card-text">
          At Apollo Agency, we offer comprehensive real estate and insurance services designed to meet your unique needs. Whether you're looking to sell or rent properties quickly and efficiently or secure the best life insurance plans, our team of experts provides targeted strategies tailored to your goals.
          </p>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Our Services</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Assistance with property rentals and leases</li>
            <li className="list-group-item">Expert guidance for property sales</li>
            <li className="list-group-item">Comprehensive property marketing strategies</li>
            <li className="list-group-item">Market analysis and competitive pricing</li>
            <li className="list-group-item">Tenant screening and management support</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6">
      <div className="card">
        <img src={LANDpic} alt="Gallery Image 2" className="img-fluid rounded card-img-top" />
        <div className="card-body">
          <h3 className="card-title">Land</h3>
          <p className="card-text">
            Apollo Agency specializes in land acquisition and sales. We provide expert guidance on market trends, zoning laws, and property valuations to help you make informed decisions whether buying or selling land.
          </p>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Our Services</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Assistance with land buying and selling</li>
            <li className="list-group-item">Guidance on zoning and legal compliance</li>
            <li className="list-group-item">Accurate land valuation services</li>
            <li className="list-group-item">Insights on market trends and opportunities</li>
            <li className="list-group-item">Support for land development and investment</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

 
  <div className="row align-items-center mb-4">
    <div className="col-md-6">
      <div className="card">
        <img src={OFFICERENT} alt="Gallery Image 3" className="img-fluid rounded card-img-top" />
        <div className="card-body">
          <h3 className="card-title">Office</h3>
          <p className="card-text">
            Apollo Agency offers customized office space solutions that match your business requirements. Whether you're looking to lease or buy, we help you find the ideal office space to grow your company.
          </p>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Our Services</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Office leasing and purchase support</li>
            <li className="list-group-item">Tailored office space recommendations</li>
            <li className="list-group-item">Guidance on workspace optimization</li>
            <li className="list-group-item">Assistance with legal and contractual processes</li>
            <li className="list-group-item">Market research and competitive pricing</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

 
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6">
      <div className="card">
        <img src={RENTALSHOP} alt="Gallery Image 4" className="img-fluid rounded card-img-top" />
        <div className="card-body">
          <h3 className="card-title">Shop</h3>
          <p className="card-text">
            Apollo Agency connects retail businesses with prime commercial properties. We specialize in securing storefronts in high-traffic areas to maximize visibility and foot traffic for your shop or business.
          </p>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Our Services</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Prime retail space leasing and purchase</li>
            <li className="list-group-item">Support for store setup and planning</li>
            <li className="list-group-item">Market research for ideal shop locations</li>
            <li className="list-group-item">Assistance with lease negotiations</li>
            <li className="list-group-item">Guidance on increasing foot traffic</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  
  <div className="row align-items-center mb-4">
    <div className="col-md-6">
      <div className="card">
        <img src={INSURANCE} alt="Gallery Image 5" className="img-fluid rounded card-img-top" />
        <div className="card-body">
          <h3 className="card-title">Insurance</h3>
          <p className="card-text">
            At Apollo Agency, we offer real estate insurance solutions to protect your property investments. Whether you're insuring a home, office, or commercial property, we provide tailored coverage options to suit your needs.
          </p>
        </div>
      </div>
    </div>
    <div className="col-md-6">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">Our Services</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">Comprehensive real estate insurance plans</li>
            <li className="list-group-item">Coverage options for homes, offices, and shops</li>
            <li className="list-group-item">Expert consultation on policy selection</li>
            <li className="list-group-item">Support for claims and documentation</li>
            <li className="list-group-item">Regular updates on policy benefits</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>






<section class="unique-agency-section">
  <div class="unique-agency-container">
    <h2 class="unique-agency-title">Why Choose Apollo Agency?</h2>

    <div class="row">
      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-home"></i></div>
          <h3 class="unique-agency-feature-title">Extensive Real Estate Portfolio</h3>
          <p class="unique-agency-feature-description">
            Access a diverse range of properties including residential, commercial, and land assets to meet every requirement.
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-handshake"></i></div>
          <h3 class="unique-agency-feature-title">Trusted Partner</h3>
          <p class="unique-agency-feature-description">
            Our team provides transparent and ethical services, building lasting relationships with our clients.
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-chart-line"></i></div>
          <h3 class="unique-agency-feature-title">Market Expertise</h3>
          <p class="unique-agency-feature-description">
            Benefit from in-depth market analysis and trends to make informed buying and selling decisions.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-users"></i></div>
          <h3 class="unique-agency-feature-title">Personalized Services</h3>
          <p class="unique-agency-feature-description">
            Tailored real estate solutions designed to match your unique needs and preferences.
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-award"></i></div>
          <h3 class="unique-agency-feature-title">Award-Winning Agency</h3>
          <p class="unique-agency-feature-description">
            Recognized for our excellence in service and commitment to client satisfaction.
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="unique-agency-feature">
          <div class="unique-agency-icon"><i class="fas fa-clock"></i></div>
          <h3 class="unique-agency-feature-title">Round-the-Clock Support</h3>
          <p class="unique-agency-feature-description">
            Enjoy 24/7 assistance from our dedicated customer support team for all your real estate needs.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>


<div><Reviews/></div>



<section id="investment-opportunities">
  <div class="section-title">
    <h2>Investment Opportunities</h2>
  </div>
  <div class="content">
    <p>Explore lucrative real estate investments, including new developments and growing markets.</p>
  </div>
</section>

<section id="client-testimonials">
  <div class="section-title">
    <h2>Client Testimonials</h2>
  </div>
  <div class="testimonials">
    <p>"The team helped me secure an amazing property. Their expertise was invaluable!" - John Doe</p>
    <p>"Fantastic experience from start to finish. Highly recommend their services!" - Jane Smith</p>
  </div>
</section>

<section id="virtual-tours">
  <div class="section-title">
    <h2>Virtual Tours</h2>
  </div>
  <div class="tour">
    <p>Take a 360-degree interactive tour of our properties.</p>
  </div>
</section>

<section id="local-expertise">
  <div class="section-title">
    <h2>Local Expertise</h2>
  </div>
  <div class="expertise">
    <p>We have an in-depth knowledge of local markets, including zoning laws and community benefits.</p>
  </div>
</section>

<section id="eco-friendly-options">
  <div class="section-title">
    <h2>Eco-Friendly Options</h2>
  </div>
  <div class="eco-properties">
    <p>Explore properties with sustainable and eco-friendly designs that benefit both you and the environment.</p>
  </div>
</section>






<section id="faq-section">
  <div class="section-title">
    <h2>Frequently Asked Questions</h2>
    <p>Answers to common questions about our services.</p>
  </div>
  <div class="faq">
    <div class="faq-item">
      <h3>1. What types of properties do you handle?</h3>
      <p>We deal with home sales and rentals, land sales and rentals, shop sales and rentals, office spaces, and insurance services.</p>
    </div>
    <div class="faq-item">
      <h3>2. Can I get assistance with property insurance?</h3>
      <p>Yes, we provide complete assistance with property insurance to safeguard your assets.</p>
    </div>
    <div class="faq-item">
      <h3>3. How can I list my property for sale or rent?</h3>
      <p>You can list your property by contacting our team. We'll guide you through the process step by step.</p>
    </div>
    <div class="faq-item">
      <h3>4. Do you offer virtual tours for properties?</h3>
      <p>Yes, we offer interactive virtual tours for selected properties to help you view them remotely.</p>
    </div>
    <div class="faq-item">
      <h3>5. What areas do you serve?</h3>
      <p>We operate in multiple regions and provide tailored services based on your location and requirements.</p>
    </div>
    <div class="faq-item">
      <h3>6. Are there any additional charges for property inspections?</h3>
      <p>No, property inspections are included in our service offerings, ensuring transparency.</p>
    </div>
    <div class="faq-item">
      <h3>7. Do you provide commercial shop spaces for rent?</h3>
      <p>Yes, we have a wide range of commercial shop spaces available for rent or purchase.</p>
    </div>
    <div class="faq-item">
      <h3>8. Can I get a valuation for my property?</h3>
      <p>Yes, we offer property valuation services to help you determine its market worth.</p>
    </div>
    <div class="faq-item">
      <h3>9. Do you assist with office space rentals?</h3>
      <p>Yes, we have office spaces in prime locations available for rent or sale.</p>
    </div>
    <div class="faq-item">
      <h3>10. How secure is the transaction process?</h3>
      <p>All transactions are handled with utmost security and legal compliance to ensure your safety.</p>
    </div>
    <div class="faq-item">
      <h3>11. Do you offer properties with flexible payment options?</h3>
      <p>Yes, we provide properties with flexible payment terms, including installment plans.</p>
    </div>
  </div>
</section>




<div>
  <Rating />
</div>
{/* <div><Upload/></div> */}
      
      <div><Footer /></div>
    </div>
    </div>
  );
}
